import { useEntity } from '@backstage/plugin-catalog-react'
import { Card, CardHeader, CardBody, Text } from '@backstage/ui'
import PodAdditionalInfoFields from './EntityFields/PodAdditionalInfoFields/PodAdditionalInfoFields'

const EntityGroupAdditionalInfoCard = () => {
  const { entity } = useEntity()

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader>
        <Text variant="title-x-small" weight="bold">
          Additional Information
        </Text>
      </CardHeader>
      <CardBody>
        {entity?.spec?.type === 'pod' && <PodAdditionalInfoFields entity={entity} />}
      </CardBody>
    </Card>
  )
}

export default EntityGroupAdditionalInfoCard
